var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRepeatingHex(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 925 800",
    opacity: 0,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    strokeWidth: 5,
    stroke: "hsl(0, 0%, 100%)",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m400-1092.448 1292.5 746.224v1492.448L400 1892.448l-1292.5-746.224V-346.224L400-1092.448Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m400-1065.313 1269 732.656v1465.313L400 1865.313l-1269-732.657V-332.657l1269-732.656Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M400-1038.177 1645.5-319.09V1119.09L400 1838.178l-1245.5-719.09V-319.088L400-1038.177Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m400-1011.042 1222 705.52v1411.043L400 1811.042l-1222-705.521V-305.521l1222-705.521Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m400-983.907 1198.5 691.954v1383.906L400 1783.907l-1198.5-691.954V-291.953L400-983.907Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m400-956.771 1175 678.385v1356.772L400 1756.77l-1175-678.385V-278.386L400-956.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m400-929.636 1151.5 664.818v1329.636L400 1729.636l-1151.5-664.818V-264.818L400-929.636Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m400-902.5 1128 651.25v1302.5L400 1702.5l-1128-651.25v-1302.5L400-902.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m400-875.365 1104.5 637.682v1275.365L400 1675.365l-1104.5-637.683V-237.683L400-875.365Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m400-848.23 1081 624.115v1248.23L400 1648.23l-1081-624.115v-1248.23L400-848.229Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m400-821.094 1057.5 610.547v1221.094L400 1621.094l-1057.5-610.547V-210.547L400-821.094Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m400-793.959 1034 596.98V996.979L400 1593.96l-1034-596.98V-196.979L400-793.96Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m400-766.823 1010.5 583.411V983.412L400 1566.823-610.5 983.412V-183.412L400-766.823Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m400-739.688 987 569.844V969.844l-987 569.844-987-569.844V-169.844l987-569.844Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m400-712.552 963.5 556.276V956.276L400 1512.552l-963.5-556.276V-156.276L400-712.552Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m400-685.417 940 542.709V942.708l-940 542.709-940-542.709V-142.708l940-542.709Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m400-658.282 916.5 529.141V929.141L400 1458.28l-916.5-529.14V-129.141L400-658.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m400-631.146 893 515.573V915.573l-893 515.573-893-515.573V-115.573l893-515.573Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m400-604.01 869.5 502.005v1004.01L400 1404.011l-869.5-502.006v-1004.01L400-604.011Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m400-576.875 846 488.437v976.876l-846 488.437-846-488.437V-88.438l846-488.437Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m400-549.74 822.5 474.87v949.74L400 1349.74l-822.5-474.87V-74.87L400-549.74Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m400-522.604 799 461.302v922.604l-799 461.302-799-461.302V-61.302l799-461.302Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m400-495.469 775.5 447.735v895.469L400 1295.469l-775.5-447.734v-895.47L400-495.468Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m400-468.334 752 434.167v868.334l-752 434.167-752-434.167V-34.167l752-434.167Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M400-441.198 1128.5-20.6v841.198L400 1241.2l-728.5-420.6V-20.599L400-441.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M400-414.063 1105-7.03V807.03l-705 407.032-705-407.032V-7.03l705-407.032Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M400-386.927 1081.5 6.536v786.928L400 1186.927l-681.5-393.463V6.536L400-386.927Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m400-359.792 658 379.896v759.792l-658 379.896-658-379.896V20.104l658-379.896Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m400-332.656 634.5 366.328v732.656L400 1132.656l-634.5-366.328V33.672L400-332.656Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m400-305.521 611 352.76v705.522l-611 352.76-611-352.76V47.239l611-352.76Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M400-278.386 987.5 60.807v678.386L400 1078.386l-587.5-339.193V60.807L400-278.386Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M400-251.25 964 74.375v651.25L400 1051.25l-564-325.625V74.375L400-251.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M400-224.115 940.5 87.943v624.114L400 1024.115l-540.5-312.058V87.943L400-224.115Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m400-196.98 517 298.49v596.98L400 996.98l-517-298.49V101.51l517-298.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m400-169.844 493.5 284.922v569.844L400 969.844-93.5 684.922V115.078L400-169.844Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m400-142.708 470 271.354v542.708L400 942.708-70 671.354V128.646l470-271.354Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m400-115.573 446.5 257.786v515.574L400 915.573-46.5 657.787V142.213L400-115.573Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m400-88.438 423 244.22v488.437L400 888.438l-423-244.22V155.782L400-88.438Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m400-61.302 399.5 230.65v461.303L400 861.302.5 630.652V169.348L400-61.302Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m400-34.167 376 217.084v434.166L400 834.167 24 617.083V182.917L400-34.167Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m400-7.031 352.5 203.515v407.032L400 807.03 47.5 603.516V196.484L400-7.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m400 20.104 329 189.948v379.896L400 779.896 71 589.948V210.052L400 20.104Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m400 47.24 305.5 176.38v352.76L400 752.76 94.5 576.38V223.62L400 47.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m400 74.375 282 162.812v325.626L400 725.625 118 562.813V237.187L400 74.375Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m400 101.51 258.5 149.245v298.49L400 698.49 141.5 549.245v-298.49L400 101.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m400 128.646 235 135.677v271.354L400 671.354 165 535.677V264.323l235-135.677Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m400 155.781 211.5 122.11v244.218L400 644.22l-211.5-122.11V277.891L400 155.78Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m400 182.917 188 108.541v217.084L400 617.083 212 508.542V291.458l188-108.541Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m400 210.052 164.5 94.974v189.948L400 589.948l-164.5-94.974V305.026L400 210.052Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m400 237.187 141 81.407v162.812l-141 81.407-141-81.407V318.594l141-81.407Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m400 264.323 117.5 67.838V467.84L400 535.677 282.5 467.84V332.16L400 264.323Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m400 291.458 94 54.271v108.542l-94 54.27-94-54.27V345.729l94-54.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m400 318.594 70.5 40.703v81.406L400 481.406l-70.5-40.703v-81.406l70.5-40.703Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m400 345.73 47 27.135v54.27l-47 27.136-47-27.136v-54.27l47-27.136Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m400 372.865 23.5 13.567v27.136L400 427.135l-23.5-13.567v-27.136l23.5-13.567Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRepeatingHex);
export default __webpack_public_path__ + "static/media/repeating-hex.38efdcd94267b7d83618444dc337bc32.svg";
export { ForwardRef as ReactComponent };